// frontend/src/modules/expenses/components/StatusBadge.tsx
import * as React from 'react';
import { statusPill, statusDot, type StatusTone } from '../../../design-system/visual';
import type { ExpenseStatus } from '../types';

const LABEL: Record<ExpenseStatus, string> = {
  draft:      'Draft',
  submitted:  'Submitted',
  approved:   'Approved',
  rejected:   'Rejected',
  reimbursed: 'Reimbursed',
};

const TONE: Record<ExpenseStatus, StatusTone> = {
  draft:      'draft',
  submitted:  'info',
  approved:   'success',
  rejected:   'destructive',
  reimbursed: 'paid',
};

export function StatusBadge({ status }: { status: ExpenseStatus }) {
  const tone = TONE[status];
  return (
    <span className={statusPill(tone)}>
      <span className={statusDot(tone)} />
      {LABEL[status]}
    </span>
  );
}
